import React, { useEffect } from "react";
import SignupForm from "../components/SignUpFrom";

function SignUp() {
  useEffect(() => {
    document.title = "Sign Up";
  }, []);
  return (
    <div>
      <SignupForm />
    </div>
  );
}

export default SignUp;
